import { CreateManyResponse } from '@/types/types';
import { Admin } from '@/types/users';
import { ApiQueryKey } from '@/configs/ApiQueryKey';
import axios, { AxiosResponse, HttpStatusCode } from 'axios';
import httpClient from './httpClient';
import EntityApi from './EntityApi';

class AdminApi extends EntityApi<Admin> {
	constructor() {
		super(ApiQueryKey.admins);
		this.createMany = this.createMany.bind(this);
	}

	async createMany(admins: Partial<Admin>[]): Promise<CreateManyResponse> {
		const client = axios.create({
			...httpClient.defaults,
			validateStatus: () => true,
		});

		const requests: Promise<AxiosResponse<Admin>>[] = admins.map((adm) =>
			client.post(this.queryKey, adm)
		);

		const responsens = await Promise.all(requests);

		return admins.reduce<CreateManyResponse>(
			(prev, current, index) => {
				if (responsens[index].status === HttpStatusCode.Created)
					prev.passed.push(responsens[index].data.email);
				else prev.rejected.push(current.email!);

				return prev;
			},
			{
				passed: [],
				rejected: [],
			}
		);
	}
}

export default new AdminApi();
